import request from '@/utils/request'

/**
 * 这是通用的js，这里有一些经常用到的请求
 **/

/** 获取购物车数据 */
export function getCarData (params) {
  return request({
    url: '/shoppingCart/web/pageShoppingCart',
    method: 'get',
    params: params
  })
}

/** 添加购物车 */
export function saveCar (productData) { // 获取token
  return request({
    url: '/shoppingCart/web/save',
    method: 'post',
    data: productData
  })
}

export function removeCar (idArray) {
  return request({
    url: '/shoppingCart/web/asyncDelete',
    method: 'post',
    params: {
      shoppingCartIds: idArray.join(',')
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/car.js